import { styled, Box, Card, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const ImageItemCont = styled(Card)(({ theme }) => ({
  margin: '10px 0 10px 40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // maxHeight: 144,
  borderRadius: 8,
  transition: '300ms',
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.1)',
    // '& $img-item-hover': {
    //   color: 'purple',
    // },
  },
  width: 'fit-content',
  [theme.breakpoints.down('xs')]: {
    alignSelf: 'center',
    margin: '10px 0',
  },
}));

export const ImageElement = styled('img')(() => ({
  maxHeight: 214,
  borderRadius: 10,
  // maxWidth: 200,
  minWidth: 50,
  minHeight: 214,
  // maxHeight: 200,
}));

export const VideoItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: 214,
  maxWidth: 333,
  minHeight: 214,
  minWidth: 333,
  borderRadius: 8,
  margin: '10px 0 10px 40px',
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    alignSelf: 'center',
    margin: '10px 0',
    maxWidth: '100%',
    minWidth: '100%',
  },
}));

export const AudioItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 382,
  height: 53,
  borderRadius: 8,
  backgroundColor: theme.palette.type === 'dark' ? '#0B0F14' : COLORS.LIGHT_BORDER,
  border: theme.palette.type === 'dark' ? 'solid 1px #18212e' : 'none',
  margin: '10px 0 10px 40px',
  alignItems: 'center',
  padding: '0px 15px',
  cursor: 'pointer',
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    alignSelf: 'center',
    margin: '10px 0',
    maxWidth: '100%',
    minWidth: '100%',
  },
}));

export const AudioInfo = styled(Box)(() => ({
  marginLeft: 15,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

export const AudioName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 242,
  overflow: 'hidden',
  [theme.breakpoints.down('xs')]: {
    width: '50%',
  },
}));

export const Duration = styled(Box)(() => ({
  fontSize: 14,
  fontWeight: 500,
  color: '#93a1b6',
}));

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  height: '100%',
  alignContent: 'flex-start',
}));

export const FileCont = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 'fit-content',
  maxWidth: 382,
  height: 53,
  borderRadius: 8,
  backgroundColor: theme.palette.type === 'dark' ? '#0B0F14' : COLORS.LIGHT_BORDER,
  border: theme.palette.type === 'dark' ? 'solid 1px #18212e' : 'none',
  margin: '10px 0 10px 40px',
  alignItems: 'center',
  padding: '0px 15px',
  cursor: 'pointer',
  position: 'relative',
  '& .documentIcon path': {
    fill: '#3e8bfe',
  },

  [theme.breakpoints.down('xs')]: {
    alignSelf: 'center',
    margin: '10px 0',
    maxWidth: '100%',
    minWidth: '100%',
  },
}));

export const FileName = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));
